import React from "react";
import { useTrialBanner } from "../../context/TrialBannerContext";
import "../../Css/Billing/TrialBanner.css";

export const TrialBannerHeaderChip: React.FC = () => {
  const { isTrialing, isCollapsed, daysLabel, expand } = useTrialBanner();

  if (!isTrialing || !isCollapsed) {
    return null;
  }

  return (
    <button
      type="button"
      className="trialBanner_headerChip"
      onClick={expand}
      aria-label={`Free trial active, ${daysLabel}. Show trial banner.`}
      title="Show trial details"
    >
      <span className="trialBanner_headerChipIcon" aria-hidden>
        <i className="fa-solid fa-hourglass-half" />
      </span>
      <span className="trialBanner_headerChipText">
        <span className="trialBanner_headerChipLabel">Trial</span>
        <span className="trialBanner_headerChipMeta">{daysLabel}</span>
      </span>
      <i className="fa-solid fa-chevron-down trialBanner_headerChipChevron" aria-hidden />
    </button>
  );
};
